import * as React from 'react';
import { useHostParts } from '~/Router/useHostParts';
export var Context = React.createContext({
    host: '',
    hostname: '',
    protocol: 'https',
    subdomain: null,
});
export var ContextProvider = function (_a) {
    var children = _a.children;
    var hostParts = useHostParts();
    return <Context.Provider value={hostParts}>{children(hostParts)}</Context.Provider>;
};
